export const normalizeStatus = (status) =>
  status?.toLowerCase?.() || '';

export const VALID_STATUSES = new Set([
  'reject',
  'rejected',
  'approved',
  'sent_for_printing',
  'started',
  'scheduled',
  'send_for_printing',
  'printing_complete',
  'released',
  'ready_to_print',
  'partially_released',
  'held',
  'failed',
  'release_failed',
]);

export const isValidStatus = (status) =>
  VALID_STATUSES.has(normalizeStatus(status));

export const isRejectedStatus = (status) =>
  normalizeStatus(status).startsWith('reject');

export const isApprovedStatus = (status) =>
  normalizeStatus(status) === 'approved';